<template>
</template>

<script>
export default {
    data: function () {
        return {
            show: false
        }
    },

    props: [
    ],

    mounted() {
    },

    watch: {
    },

    methods: {
        showReceiptDetails() {
            if (this.show == false) {
                this.show = true;
            } else if (this.show == true) {
                this.show = false;
            }
        },
    },

    components: {
    }
}
</script>
